import { Component, OnInit, ViewChild, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface, SwiperScrollbarInterface, SwiperNavigationInterface, SwiperAutoplayInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { MarketingOffer} from '../../models/presentation.model';
import { ResortComponent } from '../../shared/resort.component';
import { SearchEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
  selector: 'mkt-hero-carousel',
  templateUrl: './mkt-hero-carousel.component.html',
  styleUrls: ['./mkt-hero-carousel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MktHeroCarouselComponent {
  // Swiper Confguartion
  public mktHeroCarousel: SwiperConfigInterface = {
    runCallbacksOnInit: true,
    normalizeSlideIndex: true,
    slidesPerView: 'auto',
    loop: true,
    // loopAdditionalSlides: 1,
    loopedSlides: 0,
    // initialSlide: 1,
    scrollbar: false,
    // direction: 'horizontal',
    observer: true,
    keyboard: false,
    navigation: {
      nextEl: '.mkt-hero-carousel__btn--next',
      prevEl: '.mkt-hero-carousel__btn--prev',
    },
    // pagination:{
    //   el: '.swiper-pagination',
    //   type: 'progressbar'
    // },
    // autoplay: {
    //   delay: 5000,
    // },
    autoHeight: true,
    // freeMode: false,
    // mousewheel: false,
    fadeEffect: {
      crossFade: false
    },
    spaceBetween: 10,
    centeredSlides: true,

  }

  @Input()
  marketingOffers: Array<MarketingOffer>;
  @Input()
  index: number;
  @Output()
  searchById: EventEmitter<number>= new EventEmitter<number>();
  constructor() { }

  ngOnInit() {
  }
  @ViewChild(SwiperComponent) componentRef: SwiperComponent;
  @ViewChild(SwiperDirective) directiveRef: SwiperDirective;

  public onIndexChange(index: number): void {
    
  }

  public marketingOfferAtIndex(index:number): MarketingOffer{
    return this.marketingOffers[index];
  }

  public getMarketingOfferByTitle(title:string):MarketingOffer{
    return this.marketingOffers.where(m => m.featuredSearchGroupList.where(f => f.title == title).count() > 0 ).firstOrDefault();
  }

  public triggerSearch(searchId: number):void{
    this.searchById.emit(searchId);
  }

  public swipe():void{
    UserActivityLogger.logEvent(SearchEvents.BannerArrowClicked, {}, UserActivityLoggerOptions.AppInsightsOnly);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/hero/mkt-hero-carousel/mkt-hero-carousel.component.ts